export const checkUrl = (url, path) => "/" + url.split("/")[2] === path
